import { PageHeader } from '@/components/ui/PageHeader'
import { PlatformBreadcrumbs } from './PlatformBreadcrumbs'
import { RedisMenu } from './RedisMenu'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { DataTable } from '@/components/ui/DataTable/DataTable'
import { useRestClient } from '@/contexts/QueryProvider'
import { columns } from './PlatformUsersTable/platformUsersTableColumns'

export function PlatformUsersPage() {
  return (
    <>
      <PageHeader className="pr-3" title={<PlatformBreadcrumbs title="Users" />}>
        <RedisMenu />
      </PageHeader>
      <PlatformUsersPageContent />
    </>
  )
}

function PlatformUsersPageContent() {
  const { getSupportApiGetPlatformUsers } = useRestClient()
  const { data: users } = getSupportApiGetPlatformUsers.useSuspenseQuery(undefined)

  return (
    <>
      {/* {projects?.map((p) => <>{p.projectName},</>)} */}
      <TablePageContainer>
        <DataTable columns={columns} data={users} />
      </TablePageContainer>
    </>
  )
}
